// MARK://dhk8/admin-shell/lib/queries/units
// Unidades por-tenant (favoritos + custom) — catalog-pricing (TenantUnitService),
// tenant del JWT (RLS, anti-IDOR). Decisión Gustavo 2026-06-23: las unidades se
// eligen SIEMPRE de un catálogo (SAT c_ClaveUnidad + custom del tenant), nunca
// texto libre. `tenantUnits` trae favoritos (claves SAT recurrentes) + custom.
import { graphql } from '../../gql/index.js'

export const AdminTenantUnitsQuery = graphql(`
  query AdminTenantUnits {
    tenantUnits {
      id
      tenantId
      unitKey
      label
      symbol
      satClave
      isCustom
      isFavorite
      sortOrder
      createdAt
      updatedAt
    }
  }
`)

export const AdminSetUnitFavoriteMutation = graphql(`
  mutation AdminSetUnitFavorite($unitKey: String!, $label: String!, $symbol: String, $satClave: String, $favorite: Boolean!) {
    setUnitFavorite(unitKey: $unitKey, label: $label, symbol: $symbol, satClave: $satClave, favorite: $favorite) {
      id
      tenantId
      unitKey
      label
      symbol
      satClave
      isCustom
      isFavorite
      sortOrder
      createdAt
      updatedAt
    }
  }
`)

export const AdminCreateCustomUnitMutation = graphql(`
  mutation AdminCreateCustomUnit($label: String!, $symbol: String, $satClave: String) {
    createCustomUnit(label: $label, symbol: $symbol, satClave: $satClave) {
      id
      tenantId
      unitKey
      label
      symbol
      satClave
      isCustom
      isFavorite
      sortOrder
      createdAt
      updatedAt
    }
  }
`)

export const AdminUpdateCustomUnitMutation = graphql(`
  mutation AdminUpdateCustomUnit($id: ID!, $label: String, $symbol: String, $satClave: String, $sortOrder: Int) {
    updateCustomUnit(id: $id, label: $label, symbol: $symbol, satClave: $satClave, sortOrder: $sortOrder) {
      id
      tenantId
      unitKey
      label
      symbol
      satClave
      isCustom
      isFavorite
      sortOrder
      createdAt
      updatedAt
    }
  }
`)

export const AdminDeleteCustomUnitMutation = graphql(`
  mutation AdminDeleteCustomUnit($id: ID!) {
    deleteCustomUnit(id: $id)
  }
`)

// ── Equivalencias de unidad (unit_conversions, erp-products) ─────────────────
// Canon §2.2 (erp-products): el grafo expone tenantId (null = fila GLOBAL del
// catálogo, no editable; set = del tenant via RLS). El cliente deriva `global` de
// tenantId == null. El usuario define el factor de su unidad a una base (GR/ML/PZA)
// y el motor de erp-inventory convierte transitivo.
export const AdminUnitConversionsQuery = graphql(`
  query AdminUnitConversions {
    unitConversions {
      id
      tenantId
      fromUnit
      toUnit
      factor
    }
  }
`)

export const AdminUpsertUnitConversionMutation = graphql(`
  mutation AdminUpsertUnitConversion($input: ErpUnitConversionInput!) {
    upsertUnitConversion(input: $input) {
      id
      tenantId
      fromUnit
      toUnit
      factor
    }
  }
`)

export const AdminDeleteUnitConversionMutation = graphql(`
  mutation AdminDeleteUnitConversion($id: ID!) {
    deleteUnitConversion(id: $id)
  }
`)
